<template>
  <div style="border: 1px solid #ccc; z-index: 100; width: 100%">
    <!-- 工具栏 -->
    <Toolbar :editor="editor" :mode="mode" :defaultConfig="toolbarConfig" style="border-bottom: 1px solid #ccc" />
    <!-- 编辑器 -->
    <Editor v-model="html" style="height: 400px" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" @onChange="onChange" />
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { apiBaseURL } from '@/utils/request'
import { getToken } from '@/utils/auth';
export default {
    components: { Editor, Toolbar },
	props:{
		modelValue:{
			type: String,
			default: ''
		}
	},
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: {
				excludeKeys: ["insertImage", "insertVideo", "insertLink", "headerSelect"]
			},
            editorConfig: { 
				placeholder: '',
				readOnly: false,
				scroll: true,
				MENU_CONF: {
				  uploadImage: {
				    server: `${apiBaseURL}/sys/oss/upload?token=${getToken()}`, // 上传地址
				    fieldName: "file",
				    // 自定义插入图片
				    customInsert(res, insertFn) {
				      // res 即服务端的返回结果
				      // 从 res 中找到 url alt href ，然后插图图片
				      insertFn(res.data.src, "", "");
				    }
				  }
				}
			},
			style: {
			  height: "500px"
			},
			disabled: false,
            mode: 'default', // or 'simple'
        }
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
		onChange(editor) { 
			this.$emit("modelValue", this.html);
		},
    },
    mounted() {
        
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
}

</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>